import { format, subDays } from '@shared/wrappers/date/date';
import { getObjectSelectedData } from '@domain/object-selected';
import { createMiddleware } from '@shared/redux';
import { showWarningToast } from '@shared/toasts';
import { getEntityId } from '@shared/utils';
import { API_DATE_FORMAT } from '@shared/utils/date';
import {
    getCampaignsInfoRequest,
    getCampaignsInfoWarning,
    HANDLE_GET_CAMPAIGNS_INFO_REPORT,
    GET_CAMPAIGNS_INFO_REQUEST_SUCCEEDED,
} from './campaigns-info.state';

export const campaignsInfoMiddleware = createMiddleware({
    [GET_CAMPAIGNS_INFO_REQUEST_SUCCEEDED]: (state) => {
        const warning = getCampaignsInfoWarning(state);

        if (warning) return [showWarningToast({ message: warning.message })];
        return [];
    },
    [HANDLE_GET_CAMPAIGNS_INFO_REPORT]: (state) => {
        const params = getCampaignsInfoParams(state);
        return [getCampaignsInfoRequest(params)];
    },
});

export const getCampaignsInfoParams = (state) => {
    const objectSelected = getObjectSelectedData(state);

    return {
        clientId: getEntityId(objectSelected),
        startDate: format(subDays(new Date(), 31), API_DATE_FORMAT),
        endDate: format(new Date(), API_DATE_FORMAT),
    };
};
